export enum Routes {
  // base url
  BASE_URL = "https://sar-nakh.ir/api/",

  // auth
  INSERT_MOBILE = "send-mobile",
  VERIFY_CODE = "login",
  LOGOUT = "logout",
  AUTH = "user/find",

  // user
  USER = "user",
  EDIT_USER = "profile",
  UPDATE_COMPANY = "company",
  GET_USERS = "users",

  // default
  HOME = "home",
  ABOUT_US = "about-us",
  CONTACT_US = "contact-info",
  VERSION = "version",

  // address
  COUNTRIES = "countries",
  PROVINCES = "provinces",
  CITIES = "city",
  CITIES_BY_NAME = "city-by-name",

  CREATE_COUNTRY = "country",
  CREATE_ZONE = "zone",
  CREATE_CITY = "city-res",

  // admin
  ADMIN = "cto",
  ADMINS = "cto",
  ADD_ADMIN = "cto",
  EDIT_ADMIN = "cto",
  DELETE_ADMIN = "cto",

  // attribute
  ATTRIBUTE = "attribute",
  ATTRIBUTES = "attribute",
  ADD_ATTRIBUTE = "attribute",
  EDIT_ATTRIBUTE = "attribute",
  DELETE_ATTRIBUTE = "attribute",
  CATEGORY_ATTRIBUTES = "categories/attributes",

  // category
  CATEGORY = "category",
  CATEGORIES = "category",
  ADD_CATEGORY = "category",
  EDIT_CATEGORY = "category",
  DELETE_CATEGORY = "category",

  // seller
  SELLER = "sale-manager",
  SELLERS = "sale-manager",
  ADD_SELLER = "sale-manager",
  EDIT_SELLER = "sale-manager",
  DELETE_SELLER = "sale-manager",

  // wholesaler
  WHOLESALERS = "wholesalers",
  WHOLESALER = "wholesalers",
  WHOLESALERS_STATUS = "activation",
  CONFIRM_WHOLESALER = "wholesalers/confirm",

  // product
  PRODUCT = "product",
  PRODUCTS = "product",
  ADD_PRODUCT = "product",
  EDIT_PRODUCT = "product",
  DELETE_PRODUCT = "product",
  ADD_PRODUCT_PIC = "images",
  DELETE_PRODUCT_PIC = "images",
  VARIANT_PRODUCT_ATTRIBUTES = "products/variation",

  // customer
  CUSTOMER_PHONES_TYPES = "customer/phone-type",
  CUSTOMER_SOCIALS_TYPES = "customer/social",
  CUSTOMER_STATUS = "customer/status",
  CUSTOMER_BASE_OPTIONS = "customer/options",
  CUSTOMER_FAMILIARITY_WAYS = "frindship",
  CO_WORKERS = "customer/colleagues",
  CUSTOMER_RELIGION = "customer/religion",
  CUSTOMER_CATEGORIES = "customer/categories",
  CUSTOMER_CREDITS = "customer/credit",
  CUSTOMERS = "customer",
  CUSTOMER = "customer",
  ADD_CUSTOMER = "customer",
  EDIT_CUSTOMER = "customer",
  DELETE_CUSTOMER = "customer",
  ADD_CUSTOMER_ATTACH = "customer",
  CHANGE_CUSTOMERS_GROUP = "customer/change-groups",

  // reminder
  REMINDER_TYPES = "reminder/type",
  REMINDERS = "reminder",
  TASKS = "tasks",
  REMINDER = "reminder",
  REMINDERS_ARCHIVE = "reminder/archive",
  ADD_REMINDER = "reminder",
  EDIT_REMINDER = "reminder",
  DELETE_REMINDER = "reminder",

  // factor
  FACTOR = "factor",
  FACTORS = "factor",
  ADD_FACTOR = "factor",
  EDIT_FACTOR = "factor",
  DELETE_FACTOR = "factor",
  TODAY_FACTORS = "factors/today",
  FACTOR_STATUSES = "factor/status",
  CHANGE_FACTOR_STATUSES = "factor/status",
  FACTOR_MAIN_STATUS = "factor/main-status",
  CHANGE_FACTOR_MAIN_STATUS = "factor/main-status",

  // note
  NOTE = "note",
  NOTES = "note",
  ADD_NOTE = "note",
  EDIT_NOTE = "note",
  DELETE_NOTE = "note",

  // report
  REPORTS = "report",
  SALE_REPORT = "",
  SELLER_REPORT = "",
  PRODUCT_REPORT = "",
  CUSTOMER_REPORT = "customer/report",

  // history
  HISTORY = "",

  // company
  COMPANIES = "colleagues",
  COMPANY = "colleagues",

  // organization
  GET_PERMISSIONS = "permission",
  GET_SECTIONS_PERMISSIONS = "section",

  GET_ROLES = "role",
  CREATE_ROLE = "role",
  UPDATE_ROLE = "role",
  DELETE_ROLE = "role",

  GET_EMPLOYEES = "company_staff",
  CREATE_EMPLOYEE = "staff/add",
  UPDATE_EMPLOYEE = "company_staff",
  DELETE_EMPLOYEE = "company_staff",
  GET_EMPLOYEE_PERMISSIONS = "permissions/user",
  UPDATE_EMPLOYEE_PERMISSIONS = "permissions/user",

  // corporation
  GET_CORPS = "company",
  CREATE_CORP = "company",
  UPDATE_CORP = "company",
  DELETE_CORP = "company",

  // base
  GET_TYPE_OF_MEETINGS = "frindship",
  UPDATE_TYPE_OF_MEETING = "frindship",
  CREATE_TYPE_OF_MEETING = "frindship",
  DELETE_TYPE_OF_MEETING = "frindship",
  GET_APK_VERSION = "versions-resource",
  UPDATE_APK_VERSION = "versions-resource",
}
